import { createApp } from 'vue';

export const CraftVue = createApp({
	delimiters: ['${', '}']
})
